import 'js/footer';
import 'js/toggleText';
import 'js/adBlockerPopin';
import 'js/handlers';
import 'js/jqueryWidgets/autocomplete';
import 'js/components/destinationFullMap';
import './allPagesMain.scss';
import { pushBeforeSmoothScroll, scrollToSection } from 'js/customEvents';
import { pushOpenDatesFilter, openFilterIfExists } from 'js/scenes/MainSearchBox/customEvents';

function lazyLoad(importFn, exportName = 'default') {
  return function (...args) {
    return importFn().then((module) => {
      const fn = exportName === 'default' ? module.default : module[exportName];
      return fn(...args);
    });
  };
}

window.cleanOneTrustHtags = lazyLoad(() => import('js/cleanOneTrustHtags'), 'cleanOneTrustHtags');
window.renderAnchorScroll = lazyLoad(() => import('js/anchorScroll'));
window.pushGA4 = lazyLoad(() => import('@helpers/dataLayerPush'), 'pushGA4');
window.iframeLoaded = lazyLoad(() => import('js/iframeFullHeight'));
window.renderInputPhone = lazyLoad(() => import('js/intlTelInput'), 'renderInputPhone');
window.initLoginBlock = lazyLoad(() => import('js/loginBlock'), 'initLoginBlock');
window.checkNavigationType = lazyLoad(() => import('js/shared/checkNavigationType'));

window.pushGtm = {
  pushGA4: lazyLoad(() => import('@helpers/dataLayerPush'), 'pushGA4'),
};

window.pushContentSquare = {
  push: lazyLoad(() => import('@helpers/contentsquare')),
};

window.customEvents = {
  pushBeforeSmoothScroll,
  scrollToSection,
  pushOpenDatesFilter,
  openFilterIfExists,
};

window.reactModals = {
  render: lazyLoad(() => import('js/components/ReactModals')),
  open: lazyLoad(() => import('js/components/ReactModals'), 'openReactModalEvent'),
  close: lazyLoad(() => import('js/components/ReactModals'), 'closeReactModalEvent'),
};
